import React from 'react';


// IMPORT STYLESs
import './ContentCard.css';

function ContentCard(data) {

const title = data.title ? data.title : "Заголовок";
const point = data.point ? data.point : "Тезис";
const text = data.text ? data.text : "Текст";
const imgAlt = data.imgAlt ? data.imgAlt : "Картинка";
const imgLink = data.imgLink ? data.imgLink : "https://i.pinimg.com/originals/f5/df/d1/f5dfd16ed3bbc0b0be7f2345a08c6507.png";
const accent = data.accent;
const cardColor = data.cardColor ? data.cardColor : "";
let imgForm = '';

switch(data.imgForm) {
  case 'smallRound':
    imgForm = '20px';
    break;
  case 'round':
    imgForm = '50%';
    break;
  default:
    break;
};

  return(
    <div className='contentCard' style={{backgroundColor: cardColor}}>
      <h2 className='contentCard__title'>{title}</h2>
        <div className='contentCard__img-conteiner'>
          <img
            className='contentCard__img'
            src={imgLink}
            alt={imgAlt}
            style={{borderRadius: imgForm}}
          />
          <p className='contentCard__point'>{point}</p>
      </div>
      <p className='contentCard__text'>{text}</p>
      {data.accent && <a href='tel: +79122434390' className='contentCard__endingWord'>{accent}</a>}
    </div>
  );
}
export default ContentCard;
